import { FC } from 'react';
import { PageTitle } from '../../../_metronic/layout/core';
import { View } from './components/View';

const PlantillaPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Plantillas</PageTitle>
      <View />
    </>
  );
};

export { PlantillaPage };
